<div style="height: 100vh;width: 100vw;justify-content: center;" class="flex" >
  <div class="flex" style="flex-direction: column;justify-content: center;margin-top: -15vh;">
    <a class="layout-topbar-logo flex" routerLink="" style="color:#4338ca;font-family: 'Poppins', sans-serif;font-weight:bold; font-size:2em;" >
      <span style="width: 100%;">
        Zionn.ai(admin)
      </span>
    </a>
    <div style="width: 30vw;">
      <h1>OPA! ERRO 404!</h1>
      <p>
        Não conseguimos encontrar a página que você está buscando.
      </p>
    </div>
    <div>
      <ng-lottie [options]="animationNotFound"  width="50vw" height="50vh"/>
    </div>
  </div>
</div>

